import React, { useContext, useEffect, useState } from "react";
import { RotatingLines } from 'react-loader-spinner';
import { EmpdContext } from "../../Context";
import { Document, Page, PDFDownloadLink } from "@react-pdf/renderer";
import { createUseStyles } from "react-jss";
import DashboardCard from "./DashboardCard";
import Results from '../Results'
import { pick } from 'lodash'
import classNames from "classnames";
import { Slider } from "@base-ui-components/react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Box,
  Typography,
} from "@mui/material";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Button from "../Button";
import DownloadData from "../DownloadData";
import { globalStyles } from "../../Styles";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from '@mui/material';

interface Props {
  className?: string;
}

interface ResultProps {
	data: any;
	id: string;
}

const useStyles = createUseStyles({
  root: {},
  dataSummaryWrapper: {},
  dataSummary: {
    marginBottom: 50,
  },
  dataSummaryHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    borderBottom: "1px solid #e1e5ed",
    // "& h4": {
    //   margin: 0,
    // },
  },
  dataSummaryTypeCol: {
    flexBasis: "75%",
  },
  dataSummaryStatusCol: {
    flexBasis: "25%",
    textAlign: "right",
  },
  tableHead: {
    background: "#152E54",
    color: "#fff",
    padding: 10,
    margin: 0,
  },
  statBall: {
    width: 15,
    height: 15,
    borderRadius: "50%",
    marginRight: 10,
  },
  statCol: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "end",
    alignItems: "center",
  },
  control: {
    marginTop: 75,
    marginBottom: 30,
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    width: "100%",
    paddingBlock: "0.75rem",
    touchAction: "none",
    userSelect: "none",
  },
  track: {
    width: "100%",
    height: "1rem",
    background:
      "linear-gradient(90deg, #3660a2, lightblue, yellow, orange, #ff6464)",
    borderRadius: "0.25rem",
    userSelect: "none",
  },
  indicator: {
    borderRadius: "0.25rem",
    userSelect: "none",
  },
  thumb: {
    marginTop: 10,
    width: "0",
    height: "0",
    borderLeft: "15px solid transparent",
    borderRight: "15px solid transparent",
    borderBottom: "35px solid #152E54",
    "& h5": {
      paddingTop: 20,
      width: 100,
      transform: "translateX(-45%)",
    },
  },
  slider: {
    width: "100%",
  },
  others: {
    width: 175,
    height: 60,
    backgroundColor: "#152e541c",
    "& h5": {
      marginTop: -35,
      width: 175,
      textAlign: "center",
    },
  },
  heroButton: {
    alignSelf: "flex-start",
    marginTop: "20px",
    display: "inline-block",
  },
  activeLink: { 
    "&:hover": {
      cursor: "pointer",
    },
  }
});

const useMyContext = () => {
  const context = useContext(EmpdContext);
  if (!context) {
    throw new Error("No provider found for Context");
  }
  return context;
};

const DataSummaryCard = ({ className }: Props) => {
  const context = useMyContext();
  const {
    patientResult,
    selectedCategory,
    setSelectedCategory,
    writePatientData,
    writeComplete,
    mergeData,
    isLoading,
    authUser,
	schemaName,
	demoTable,
  } = context;

  const [data, setData] = useState<any>(null);
  const value = null;

  useEffect(() => {
  }, []);

  const classes = useStyles();

  return (
    <>
      <DashboardCard
        title={"My Patients"}
        className={classNames(classes.root, className)}
      >
          {isLoading && (
            <RotatingLines
                strokeColor="#152E54"
                strokeWidth="3"
                animationDuration="1.00"
                width="48"
                visible={true}
            />
          )}
          {!isLoading &&(
        	<div className={classes.dataSummaryWrapper}>
              	<div className={classes.dataSummary}>
					<Autocomplete
                 	   sx={{
                    	    width: 500,
                        	"& .MuiOutlinedInput-root": {
                            	color: "#002F6C",
	                            // Class for the border around the input field
    	                        "& .MuiOutlinedInput-notchedOutline": {
        	                        borderColor: "#002F6C",
            	                    borderWidth: "2px",
                	            },
                    	    },
                        	// Class for the label ofthe input field
	                        "& .MuiInputLabel-outlined": {
    	                        color: "#002F6C",
        	                },
            	        }}
                	    onChange={(event: React.SyntheticEvent, value: any) => {
	                  	}}
    	             	renderInput={(params) => <TextField {...params} label={`Patient Select`} />}
        	          	options={[]}
                	  	value={value}
                	/>
            	</div>
			</div>
           )}
      </DashboardCard>
    </>
  );
};

export default DataSummaryCard;
